import Seo from '../components/Seo.jsx'
import Container from '../components/Container.jsx'

export default function GdprCompliance() {
  return (
    <>
      <Seo
        title="GDPR Compliance"
        description="Learn how Spectranox complies with the General Data Protection Regulation (GDPR) to protect user data and privacy."
        path="/gdpr"
      />
      <main className="min-h-screen bg-[#020617] pt-32 pb-24 text-slate-100 antialiased">
        <Container className="max-w-4xl">
          <div className="border-b border-slate-800 pb-8">
            <span className="font-mono text-xs uppercase tracking-widest text-cyan-500">Legal Agreement</span>
            <h1 className="mt-3 font-display text-4xl font-extrabold tracking-tight text-white sm:text-5xl">
              GDPR Compliance
            </h1>
            <p className="mt-4 text-sm text-slate-400">Last updated: July 2, 2026</p>
          </div>

          <div className="prose prose-invert mt-12 space-y-8 text-slate-300">
            <section className="space-y-3">
              <h2 className="text-xl font-bold text-white">1. GDPR Overview</h2>
              <p className="leading-relaxed">
                The General Data Protection Regulation (GDPR) is a comprehensive data privacy law enacted in the European Union (EU) that regulates how personal data of EU residents is collected, stored, processed, and secured.
              </p>
              <p className="leading-relaxed">
                Spectranox is committed to protecting the privacy of our customers and visitors. We adhere strictly to the core principles of data protection as defined under the GDPR.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-bold text-white">2. Our GDPR Principles</h2>
              <p className="leading-relaxed">
                In handling personal information, Spectranox practices the following:
              </p>
              <ul className="list-disc list-inside ml-4 space-y-1">
                <li><strong>Data Minimization:</strong> We only request and process personal details (such as email, name, phone) that are strictly necessary to conduct project operations.</li>
                <li><strong>Storage Limitation:</strong> We retain client data only as long as necessary to complete project contracts or meet statutory financial bookkeeping requirements.</li>
                <li><strong>Transparency:</strong> We tell you exactly what data we collect, why we collect it, and where it goes.</li>
                <li><strong>Confidentiality &amp; Hardening:</strong> All database infrastructures and form leads tables are hardened against leakage using modern encryption standards.</li>
              </ul>
            </section>

            <section className="space-y-3 bg-slate-900/40 border border-slate-800 p-5 rounded-2xl">
              <h2 className="text-xl font-bold text-white">3. Your Data Rights Under GDPR</h2>
              <p className="leading-relaxed">
                Under GDPR regulations, EU individuals have the following enforceable rights:
              </p>
              <ul className="list-disc list-inside ml-4 space-y-2 mt-2">
                <li><strong>Right of Access:</strong> You can ask for a complete breakdown of all your personal information currently stored in our records.</li>
                <li><strong>Right to Rectification:</strong> You can request immediate correction of inaccurate or incomplete personal records.</li>
                <li><strong>Right to Erasure ("Right to be Forgotten"):</strong> You have the right to demand that we delete all your personal database records (subject to compliance with tax/contractual laws).</li>
                <li><strong>Right to Data Portability:</strong> You can request that we export your personal data in a structured, machine-readable format.</li>
                <li><strong>Right to Object &amp; Restrict Processing:</strong> You can opt out of any marketing processing, trackers, or cookies at any time.</li>
              </ul>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-bold text-white">4. Exercising Your Data Rights</h2>
              <p className="leading-relaxed">
                To submit a request to view, modify, or erase your personal information, or to submit a general inquiry regarding our data handling procedures, email us at <strong className="text-white">dpo@spectranox.com</strong>. We will respond within the mandatory 30-day window.
              </p>
            </section>
          </div>
        </Container>
      </main>
    </>
  )
}
